import ReactGA from 'react-ga';

import store from 'store';
import * as types from 'misc/types';
import { popup_icon_type } from 'components/shared/popup/Popup';
import * as endpoint from 'misc/endpoint';

// Get text from store that has been loaded from cms
export function getText(id, fallback) {
    fallback = fallback ? fallback : '';

    if (!store.getState().texts.data) return fallback;

    const text = store.getState().texts.data.find(text => text.id === id);
    return text ? text.message : fallback;
}

// Get media from cms
export function getMedia(id) {
    return endpoint.API_URL.CMS + 'medias/' + id + '?company=DIGIMAIL';
}

// Get tag from store that has been loaded from cms
export function getTag(tags, id) {
    const foundTags = tags.data.filter(function(t) {
        return t.id === id;
    });
    return foundTags.length > 0 && foundTags[0] ? foundTags[0].title : '';
}

/**
 * Payload to send with POPUP_SHOW action in order to show bankid menu
 * @param {*} actionType - action name defined in types.js
 * @param {*} cancelMessage - cancel message to be shown in log if user cancels
 */
export function getBankIdPopupData(actionType, cancelMessage) {
    return {
        type: types.POPUP_SHOW,
        payload: {
            show: true,
            icon: popup_icon_type.bankid,
            header: '',
            text: getText('_1_TextLoginMobilBankID', 'Starta din BankID-app och följ anvisningarna'),
            noButtons: true,
            showBankIdMenu: true,
            cancelAction: { type: actionType.FAILURE, error: cancelMessage }
        }
    };
}

// Check if content type is of the correct type, checking with correctTypes values
export function isCorrectContentType(contentType, correctTypes) {
    let isCorrectType = false;
    correctTypes.forEach(function(correctType) {
        if (contentType.indexOf(correctType) !== -1) {
            isCorrectType = true;
        }
    });
    return isCorrectType;
}

// Get redirect url that is defined in path
export function getRedirectUrl() {
    let url = window.location.href.split('/redirect');
    if (url[1] && url[1].length > 3) {
        return url[1];
    }
    return undefined;
}

// Google analytics tracking
export function trackGA(title) {
    // Get path
    let url = window.location.href.split('#');

    // Track page view
    ReactGA.pageview(url[1], title);

    // Track event
    ReactGA.event({
        category: 'Digimail K3',
        action: title,
        label: url[1]
    });
}

// Truncate string and add ellipsis if longer than n characters
String.prototype.trunc =
    String.prototype.trunc ||
    function(n) {
        return this.length > n ? this.substr(0, n - 1) + '...' : this;
    };



// WEBPACK FOOTER //
// ./src/misc/helpers.js